// extracted by mini-css-extract-plugin
export var conversationListItem = "_wq-2";
export var fullBleedList = "_wq-3";
export var messageText = "_wq-1";
export var previewText = "_wq-0";